const TemplateHeader = ({
    title,
    subtitle,
}) => {

    return (

        <div>

            <h4>

                {title}

            </h4>

            <small>

                {subtitle}

            </small>

        </div>

    );

};

export default TemplateHeader;